<template>
    <ActionIconButton
        is-rounded
        icon="fa-solid fa-robot"
        icon-class="icon-color"
        size="xl"
        :title="$t('Open assistant')"
        :aria-label="$t('Open assistant')"
        aria-haspopup="dialog"
        @click="$emit('openAssistant')"
    />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ActionIconButton from "@/components/buttons/ActionIconButton.vue";

export default defineComponent({
    components: {
        ActionIconButton,
    },
    name: "UseLLmButton",
    emits: ["openAssistant"],
});
</script>
